import { callApi, SERVER_TYPES } from "@amplio-common/api";
import { schema } from "normalizr";
import _ from "lodash";

const studentSchema = new schema.Entity("students", {
  // goal_set: clinicalContentShemas.GOAL_ARRAY
}, {
  idAttribute: user => user.id,
});

const therapistSchema = new schema.Entity("therapists", {
}, {
  idAttribute: user => user.id,
});

export const userSchemas = {
  STUDENT: studentSchema,
  THERAPIST: therapistSchema,
};


const treatmentSchema = new schema.Entity(
  "treatments",
  {
    student: userSchemas.STUDENT,
    therapist: userSchemas.THERAPIST,
  },
  {
    idAttribute: treatment => treatment.id,
  },
);

export const Schemas = {
  TREATMENT: treatmentSchema,
  TREATMENT_ARRAY: [treatmentSchema],
};

export const loadTreatments = (filters, useSchema = true) => {
  const queryParams = filters
    ? Object.keys(filters)
      .reduce(
        (res, item) =>
          (res += filters[item] !== null || filters[item] !== undefined ? `${item}=${filters[item]}&` : ""),
        "?",
      )
      .slice(0, -1)
    : "";
  return callApi(`treatments/${queryParams}`, { method: "GET" }, useSchema ? Schemas.TREATMENT_ARRAY : null);
};

export const getControlBoardTreatments = (filters) => {
  const queryParams = filters ? Object.keys(filters).reduce((res, item) =>
    (res += filters[item] !== null || filters[item] !== undefined ? `${item}=${filters[item]}&` : ""),
  "?").slice(0, -1)
    : "";
  return callApi(`treatments/control_board/${queryParams}`, { method: "GET" });
};

export const getTreatmentsStats = (filters) => {
  const queryParams = filters ? Object.keys(filters).reduce((res, item) =>
    (res += filters[item] !== null || filters[item] !== undefined ? `${item}=${filters[item]}&` : ""),
  "?").slice(0, -1)
    : "";
  return callApi(`treatments/control_board_stats/${queryParams}`, { method: "GET" });
};

export const loadTreatmentActivity = treatment => (
  callApi(`treatment/get/?id=${treatment}`, {
    method: "GET",
  })
);

export const loadTreatment = (treatmentId, filters) => {
  if (localStorage.getItem("code_login_token") || localStorage.getItem("class_login_token")) {
    return callApi(`student_code/${treatmentId}/treatments/`, { method: "GET" });
  }
  const queryParams = filters
    ? Object.keys(filters)
      .reduce((res, item) => (res += filters[item] ? `${item}=${filters[item]}&` : ""), "?")
      .slice(0, -1)
    : "";
  return callApi(`treatments/${treatmentId}/${queryParams}`, {
    method: "GET",
  });
};

// updateTreatment -- used to deleteTreatment too
export const updateTreatment = (treatmentId, treatment, useSchema = true) => callApi(
  localStorage.getItem("code_login_token") || localStorage.getItem("class_login_token") ? `student_code/${treatmentId}/treatments/` : `treatments/${treatmentId}/`,
  {
    method: "PATCH",
    type: "JSON",
    body: { ...treatment },
  },
  useSchema ? Schemas.TREATMENT : null,
);

export const updateLogVideo = (treatmentId, data = {}) => callApi(
  `treatments/${treatmentId}/video_log/`,
  {
    method: "POST",
    type: "JSON",
    body: { ...data },
  },
);

export const saveTreatmentActivityList = (currentList, treatmentId, params = null) =>
  callApi(`treatments/${treatmentId}/activity_stack/`, {
    method: "POST",
    type: "JSON",
    body: { activity_stack: currentList },
    params,
  });


export const cancelTreatment = (treatmentId, treatment, useSchema = true) => callApi(
  `treatments/${treatmentId}/`,
  {
    method: "DELETE",
    type: "JSON",
    body: { ...treatment },
  },
  useSchema ? Schemas.TREATMENT : null,
);

export const rescheduleTreatment = (treatmentId, treatment, useSchema = true, params) => callApi(
  `treatments/${treatmentId}/reschedule/`,
  {
    method: "POST",
    type: "JSON",
    body: { ...treatment },
    params,
  },
  useSchema ? Schemas.TREATMENT : null,
);

export const createTreatment = (treatment, useSchema = true) => callApi(
  "treatments/",
  {
    method: "POST",
    type: "JSON",
    body: { ...treatment },
  },
  useSchema ? Schemas.TREATMENT : null,
);

export const cancelRecurringTreatment = (eventTemplateId, cancelInfo) => callApi(
  `event-templates/${eventTemplateId}/`,
  {
    method: "DELETE",
    type: "JSON",
    body: { ...cancelInfo },
  },
  undefined,
  SERVER_TYPES.CALENDAR,
);

export const createEventTemplates = (eventTemplate) => callApi(
  "event-templates/",
  {
    method: "POST",
    type: "JSON",
    body: { ...eventTemplate },
  },
  undefined,
  SERVER_TYPES.CALENDAR,
);

export const loadEventTemplate = (params) => callApi(
  "event-templates/",
  {
    method: "GET",
    params,
  },
  undefined,
  SERVER_TYPES.CALENDAR,
);

export const updateEventTemplates = (eventTemplateId, eventTemplate, params) => callApi(
  `event-templates/${eventTemplateId}/`,
  {
    method: "PATCH",
    type: "JSON",
    params,
    body: { ...eventTemplate },
  },
  undefined,
  SERVER_TYPES.CALENDAR,
);

export const createEventExclusions = (eventInfo) => callApi(
  "event-exclusions/",
  {
    method: "POST",
    type: "JSON",
    body: { ...eventInfo },
  },
  undefined,
  SERVER_TYPES.CALENDAR,
);
export const changeEventExclusion = (eventInfo, event_exclusion_id) => callApi(
  `event-exclusions/${event_exclusion_id}/`,
  {
    method: "PATCH",
    type: "JSON",
    body: { ...eventInfo },
  },
  undefined,
  SERVER_TYPES.CALENDAR,
);

export const getTreatmentByEventTemplate = (eventTemplateId) => callApi(
  `event-templates/${eventTemplateId}/treatments`,
  {
    method: "GET",
  },
  undefined,
  SERVER_TYPES.CALENDAR,
);

export const loadPrevTreatment = treatmentId => callApi(`treatments/${treatmentId}/prev_treatment/`, {
  method: "GET",
});

export const getWorkTypes = () => callApi("work_types/", {
  method: "GET",
});

export const saveWorkTime = (data) => callApi("work_times/", {
  method: "POST",
  type: "JSON",
  body: data,
});

export const updateWorkTime = (id, data) => callApi(`work_times/${id}/`, {
  method: "PUT",
  type: "JSON",
  body: data,
});

export const deleteWorkTime = (id) => callApi(`work_times/${id}/`, {
  method: "DELETE",
  type: "JSON",
});

export const loadMeasurements = (studentId, treatmentId) => callApi(`measurements/${studentId}/${treatmentId}/`,
  {
    method: "GET",
  },
  undefined,
  SERVER_TYPES.ANALYTICS);

export const loadSessionStart = treatmentId => callApi(`treatments/${treatmentId}/session_start/`, {
  method: "GET",
});

export const getVideoToken = (treatmentId) => callApi(`treatments/${treatmentId}/generate_opentok_token/`, {
  method: "GET",
});

export const getAltVideoToken = (treatmentId, isPending = false, studentId = null) => {
  const url = `treatments/${treatmentId}/generate_twilio_token/?is_pending=${isPending}${studentId ? `&student_id=${studentId}` : ""}`;
  return callApi(url, { method: "GET" });
};

export const unlockTreatment = treatmentId => callApi(`treatments/${treatmentId}/unlock_treatment/`, {
  method: "GET",
});

// export const getAvailabilitiesByStudent = studentId => callApi(`treatments/availabilities/?student_id=${studentId}`, {
//   method: "GET",
// });

export const createAvailabilityBlock = data => callApi("availability_blocks/", {
  method: "POST",
  type: "JSON",
  body: { ...data },
});

export const deleteAvailabilityBlock = id => callApi(`availability_blocks/${id}/`, {
  method: "DELETE",
});

export const getGameStatistics = (treatmentId, studentId) => callApi(`courses/game_statistics/?treatment_id=${treatmentId}&student_id=${studentId}`, {
  method: "GET",
});

export const updateChatReadMessages = (treatmentId, data) => callApi(`treatments/${treatmentId}/update_read_messages/`, {
  method: "POST",
  type: "JSON",
  body: { ...data },
});

export const createTreatmentMetaDataPromise = (treatmentId, data) => callApi(`treatments/${treatmentId}/log_user_metadata/`, {
  method: "POST",
  type: "JSON",
  body: { ...data },
});

export const createTreatmentEventPromise = (treatmentId, data) => callApi(`treatments/${treatmentId}/log_metric_event/`, {
  method: "POST",
  type: "JSON",
  body: { event: { ...data } },
});

export const createTreatmentMultipleEventPromise = (treatmentId, data) => callApi(`treatments/${treatmentId}/log_metric_multiple_events/`, {
  method: "POST",
  type: "JSON",
  body: { events: data },
});

export const getPlaylistReport = list => callApi("treatments/playlist_report/", { method: "POST", body: { list }, type: "PDF" });
export const getPlaylistReportWithParams = (list, params) => {
  const uri = "treatments/playlist_report/";
  const queryParams = new URLSearchParams("");
  const keys = Object.keys(params);
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  keys?.forEach((key) => {
    queryParams.append(key, params[key]);
  });
  const finalUri = !_.isEmpty(params) ? `${uri}?${queryParams.toString()}` : uri;
  return callApi(finalUri, { method: "POST", body: { list }, type: "PDF" });
};

export const createAnonymousStudent = (firstName, lastName, grade, selectedFocusArea) => callApi("students/",
  { method: "POST",
    type: "JSON",
    body: { first_name: firstName, last_name: lastName, student_grade: grade, skills: selectedFocusArea },
  });

export const resetActivityPpromise = (student_id, activity_id) => callApi("activities/state/",
  { method: "POST",
    body: { student_id,
      activity_id,
      //activity_session_id: activitySessionId,
      activity_state: "{}",
    },
  });
